import LoadingScreenComponent from '../../components/LoadingScreen';

// ----------------------------------------------------------------------

export default function LoadingScreen() {
  return <LoadingScreenComponent />;
}
